import React, { useEffect, useState } from 'react';
import RecapProductList from 'components/Content/Recap/RecapProductList/RecapProductList';
import getNthLevelCategoryApi from 'services/api/search-n-browse/getNthLevelCategory';
import { wrapFunctionalComponent } from 'utils/framework';
import { LANDING_PAGE } from 'constants/ShopYourStore';

const { getNthLevelCategory } = getNthLevelCategoryApi;

function RecapProductListCategory(props) {
    const { action = {} } = props;
    const { urlParameters = '' } = action;

    const [skuList, setSkuList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const shouldRender = isLoading || (!isLoading && !!skuList.length);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const queryParams = Object.fromEntries(new URLSearchParams(urlParameters));
                const apiPayload = {
                    ...queryParams,
                    catalogSeoName: action?.page?.slug,
                    page: 1,
                    pageSize: LANDING_PAGE.MAX_ITEMS_FOR_RECAP
                };

                const category = await getNthLevelCategory(apiPayload);
                const products = category?.products || [];

                setSkuList(products);
            } catch (error) {
                Sephora.logger.error('Failed to call BXS');
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [props.contextKey]);

    return (
        <RecapProductList
            {...props}
            shouldRender={shouldRender}
            isLoading={isLoading}
            skuList={skuList}
        />
    );
}

export default wrapFunctionalComponent(RecapProductListCategory, 'RecapProductListCategory');
